export default {
  banner: "Banner",
  AddBanner: "AddBanner",
  editBanner: "EditBanner",
};
